"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _log = require("@/utils/log");
var _resource = require("@/api/resource");
var _hike = require("@/api/hike");
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const defaultValue = [];
var _default = exports.default = {
  name: 'HikeResource',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentResource: {
      type: Array,
      default: defaultValue
    },
    hikeId: {
      type: String,
      default: ''
    },
    fromId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dragging: false,
      fullscreenloading: false,
      resourceLibrary: [],
      resources: [],
      resourcesWithTitle: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        sort: '+title',
        q: undefined,
        category: 'event-resource'
      }
    };
  },
  computed: {
    filterResLibrary() {
      return this.resourceLibrary.filter(v => {
        if (this.isNotInTraining(v)) {
          return v;
        }
        return false;
      });
    }
  },
  watch: {
    resourcesWithTitle: {
      handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal);
      },
      deep: true
    }
  },
  created() {
    this.getResourceLibrary();
    if (this.hikeId === 'copy') {
      if (this.$route.query.r === 'true') {
        this.getSelectedResource(this.fromId);
      }
    } else {
      this.getSelectedResource(this.hikeId);
    }
    this.resources = this.parentResource;
  },
  methods: {
    getResourceLibrary(newSearch) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      if (newSearch) {
        this.query.page = 1;
      }
      (0, _resource.fetchList)(token, this.query).then(response => {
        (0, _log.showDebugLog)('hike-getResourceLibrary-API', response.data);
        this.resourceLibrary = response.data.rows;
        this.total = response.data.count;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getResourceLibrary-API-error', error.repsonse.data.message);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getSelectedResource(id) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _hike.getResourceByHikeId)(token, id).then(response => {
        (0, _log.showDebugLog)('hike-getResourceLibrary-API', response.data);
        this.resourcesWithTitle = response.data.rows;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getResourceLibrary-API-error', error.repsonse.data.message);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    passBackToParent(res) {
      var resList = [];
      for (var i = 0; i < this.resourcesWithTitle.length; ++i) {
        resList.push(this.resourcesWithTitle[i].id);
      }
      this.$emit('updateParentResource', resList);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getResourceLibrary(false);
    },
    changeResourceSelection(value, id, type, title) {
      if (value) {
        this.resourcesWithTitle.push({
          id,
          type,
          title
        });
      } else {
        /*
        const removedItem = _.remove(this.resourcesWithTitle, (item) => {
          return item.id === id
        })
        */

        this.resourcesWithTitle = this.resourcesWithTitle.filter(item => {
          return item.id !== id;
        });
      }
    }
  }
};